import "./TheAuthor.module.css";
import Header from "@/reusable_sections/Header";
import OurCulinaryPhilosophy from "./sections/OurCulinaryPhilosophy";
import WisdomMindset from "./sections/WisdomMindset";
import GlobalReaderReviews from "./sections/GlobalReaderReviews";
import Footer from "@/reusable_sections/Footer";
export default function TheAuthorPage() {
  return <div>
      <Header />
      <OurCulinaryPhilosophy />
      <WisdomMindset />
      <GlobalReaderReviews />
      <Footer />
    </div>;
}